/** URL de un POST de imagen (logo / portada / frontend-config). */
export function pickUploadedMediaUrl(payload) {
  if (!payload || typeof payload !== 'object') return '';
  const nested = payload.data && typeof payload.data === 'object' && !Array.isArray(payload.data)
    ? payload.data
    : {};
  return String(
    nested.url || nested.path || payload.url || payload.cover_url || payload.logo_url || '',
  ).trim();
}
